<template>
  <div>
    <BusinessSwitchOverlay />
    <LazySignModal v-if="showLegalModal" />
    <nav :style="appStyleProps">
      <div class="top-banner bg-white p-3 p-lg-0 d-flex flex-column justify-content-center">
        <div class="d-flex justify-content-between align-items-center">
          <MarketplaceLogo />
          <AppNav class="mx-lg-5 sign-out sticky-sign-out text-end"
            :full="true"
            :hide-app-cta="true"
            :hide-contact-info="true" />
        </div>
      </div>
    </nav>
    <div class="d-flex flex-column mh-100vh"
         data-smooth-scroll="main"
         :class="{'customized-affiliate': !!affiliateCustomizations}"
         :style="appStyleProps">
      <div class="expectations-container container d-flex flex-column flex-grow-1">
        <slot />
      </div>
    </div>
    <ChatBot v-if="authUser" />
  </div>
</template>

<script>
import { LazySignModal } from '#components'
import { computed } from 'vue'
import { mapState } from 'pinia'
import { DEFAULT_THEME_COLOR } from '~/libs/customizations'
import SmoothScroll from '~/libs/smooth-scroll'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import { useRootStore } from '~/store/root'
import { useBorrowerStore } from '~/store/borrower'
import AppNav from '~/components/AppNav.vue';
import ChatBot from '~/components/ChatBot.vue'
import { get } from 'es-toolkit/compat'
import BusinessSwitchOverlay from '~/components/BusinessSwitchOverlay.vue'

export default {
  name: 'expectations-story-arc',
  components: {
    BusinessSwitchOverlay,
    LazySignModal,
    AppNav,
    ChatBot,
  },
  async setup() {
    const borrowerStore = useBorrowerStore()
    const rootStore = useRootStore()
    const affiliateCustomizationStore = useAffiliateCustomizationStore()
    const { showLegalModal } = storeToRefs(borrowerStore)

    rootStore.setPageTitle(affiliateCustomizationStore.headTitlePrefix + ' - Marketplace Application')
    rootStore.setLendioFavicons()

    useHead({
      title: rootStore.pageTitle,
      link: rootStore.favicons,
      meta: [
        {
          name: 'theme-color',
          content: computed(() => {
            return get(affiliateCustomizationStore, 'appStyleProps.--app-aside-background-color', DEFAULT_THEME_COLOR)
          })
        },
      ],
    })

    return {
      showLegalModal
    }
  },
  data() {
    return {
      avatarErrored: false,
    }
  },
  computed: {
    ...mapState(useRootStore, ['authUser']),
    ...mapState(useAffiliateCustomizationStore, [
      'appStyleProps',
      'affiliateCustomizations',
    ]),
  },
  watch: {
    '$route.path' () {
      SmoothScroll.goTo(0)
      SmoothScroll.scrollElementsTop('[data-smooth-scroll="main"]')
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'assets/styles/affiliate-customizations/affiliate-customizations-variables';

.mh-100vh {
  min-height: 100vh;
}

.top-banner {
  border-bottom: 1px solid $neutral-200;
  width: 100vw;
  position: fixed;
  z-index: 999; // This value must be higher than it's children's z-index values or children may not appear above other DOM elements
  min-height: 68px;

  &.customized-affiliate {
    background: $app-body-background-color !important;
  }
}

.sign-out {
  max-height: 45px;
}

.expectations-container {
  max-width: 560px;
  padding-top: 86px;

  @include media-breakpoint-up(lg) {
    padding-top: 122px;
  }
}
</style>
